export const collectionKeys = {
  all: ['collections'] as const,
  lists: () => [...collectionKeys.all, 'list'] as const,
  listWithItems: () => [...collectionKeys.lists(), 'items'] as const,
  listSearch: () => [...collectionKeys.lists(), 'search'] as const,
  details: () => [...collectionKeys.all, 'detail'] as const,
  playNext: () => [...collectionKeys.all, 'play-next'] as const,
  detail: (id: string) => [...collectionKeys.details(), { id }] as const,
} as const;
